<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection" ref="histroryRef"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData" @action-click="actionClick">
            <template #col-append="{ col, row, rIndex }">
                <span size="mini" :key="encryptionKey" v-if="['newValueName','newValue','oldValueName','oldValue'].includes(col.prop) && row.updateFieldCode==='id_number'" type="text"
                 :title="row[col.prop]">
                   {{ encryptionHandle(row[col.prop] || '', col.prop,row.id) }}
                     <img v-if="encryptionHandle(row[col.prop], col.prop,row.id)" :class="['text-eyes']" @click="handleChangeText(col,row)"
                        :src="encryption[col.prop+row.id] ? iconOpenEyes : iconCloseEyes" alt="">
                </span>
                <span v-else>{{ row[col.prop] }}</span>
            </template>
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getBiddingAccountRecordApi } from '@mdm/api/customer/biddingAccountManage.js';
import { computed, reactive, toRefs, ref } from '@vue/composition-api';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
import _ from 'lodash';
export default {
    components: {
        lotsPagination, tableBox
    },
    props: {
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: { // 表格操作信息，不传默认为空
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        // eslint-disable-next-line complexity
        const TABLECONFIG = computed(() => {
            return config;
        });
        const convertEmptyStringsToNull = (obj) => {
            return _.mapValues(obj, value => {
                if (typeof value === 'string') {
                    return _.trim(value) === '' ? null : value;
                }
                return value;
            });
        };
        class IhistoryTalbeClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.relationId = props.detailData.id;
                condition.orderBy = 'create_time';
                condition.orderByType = 'desc';
                condition = convertEmptyStringsToNull(condition);
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    subTabTable.totalData.value = res.data.list || [];
                    subTabTable.pageTotal.value = res.data.totalCount || 0;
                }
            }
        };
        const subTabTable = new IhistoryTalbeClass({
            Api: {
                listApi: getBiddingAccountRecordApi
            }
        });

        const state = reactive({
            searchHeaderParams: {}
        });

        const actionClick = (event, row) => { };
        const encryption = ref({
            idNumber: false
        });
        const encryptionKey = ref(1);
        const handleChangeText = (item, row) => {
            encryption.value[item.prop + row.id] = !encryption.value[item.prop + row.id];
            encryptionKey.value++;
        };
        // 对应加密方法
        const menuList = {
            newValueName: 'idCard',
            newValue: 'idCard',
            oldValueName: 'idCard',
            oldValue: 'idCard'
        };
        const encryptionHandle = (val, p, id) => {
            const { desensitization } = otherUtils;
            const prop = menuList[p];
            if (!desensitization[prop]) return '';
            if (encryption.value[p + id]) return val;
            return desensitization[prop](val);
        };
        const getHistoryList = () => {
            subTabTable.getList();
        };
        return {
            ...toRefs(state),
            getHistoryList,
            config,
            TABLECONFIG,
            subTabTable,
            actionClick,
            iconCloseEyes,
            iconOpenEyes,
            encryption,
            encryptionKey,
            handleChangeText,
            encryptionHandle
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {

    // margin-top: 15px;
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .mip-page-link {
        color: #4285f5;
        cursor: pointer;

        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .price-icon {
        font-size: 12px;
        cursor: pointer;
        color: #000;
    }

    .icon-active {
        color: #4285f5 !important;
    }
}
</style>
